<template>
    <card :minify="minified">
        <card-header v-if="!minified">
            <card-title>
                <translate>abgeschlossene Aufträge (90 Tage)</translate>
            </card-title>
        </card-header>
        <card-content>
            <table class="table table--stripped">
                <thead>
                <tr>
                    <th>
                        <translate>PF-Nr</translate>
                    </th>
                    <th class="text-center">
                        <translate>Zeichnung</translate>
                    </th>
                    <th class="text-right">
                        <translate>Stück</translate>
                    </th>
                    <th class="text-right">
                        <translate>Auftragspreis</translate>
                    </th>
                    <th class="text-right">
                        <translate>geplanter Produktionsstart</translate>
                    </th>
                    <th class="text-right">
                        <translate>geplanter Versandtermin</translate>
                    </th>
                    <th class="text-right">
                        <translate>Liefertermin</translate>
                    </th>
                    <th class="text-center">
                        <translate>Produktionsfortschritt</translate>
                    </th>
                    <th class="text-center">
                        <translate>WBS</translate>
                    </th>
                    <th class="text-center">
                        <translate>Status</translate>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="order in completedOrdersTable" :key="order.index">
                    <td>
                        <Link :href="order.url">{{ order.ask_for_quote.pfnumber }}</Link>
                    </td>
                    <td class="text-center">
                        <file-download :sketch-file="order.ask_for_quote?.producer_sketch_file"
                                       v-if="order.ask_for_quote?.producer_sketch_file"/>
                        <file-download :cad-file="order.ask_for_quote?.producer_cad_file"
                                       v-if="order.ask_for_quote?.producer_cad_file"/>
                    </td>
                    <td class="text-right">{{ order.amount }}</td>
                    <td class="text-right">{{ order.price_string }}</td>
                    <td class="text-right">{{ order.planned_production_start_at_string }}
                    </td>
                    <td class="text-right">{{ order.shipping_date }}</td>
                    <td class="text-right">{{ order.delivery_date_string }}</td>
                    <td class="text-center">
                        <production-progress-icons :producer-status="order.producer_status"/>
                    </td>
                    <td class="text-center">
                        <link-button :route="this.$$route('order.consignment-bill.pdf', {'producerOrder': order.id})"
                                     target="_blank" dense="true" icon="document-file-download"/>
                    </td>
                    <td class="text-center">
                        <translate>{{ order.status_string }}</translate>
                    </td>
                </tr>
                <tr v-if="noOrders">
                    <td colspan="10" class="text-center">
                        <strong>
                            <translate>keine Einträge vorhanden</translate>
                        </strong>
                    </td>
                </tr>
                </tbody>
            </table>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardTitle from '@partfactory/Shared/Card/CardTitle';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FileDownload from '@partfactory/Shared/Elements/FileDownload';
import ProductionProgressIcons from '@partfactory/Shared/Elements/ProductionProgressIcons';
import LinkButton from '@partfactory/Shared/Elements/LinkButton';
import {useForm} from '@inertiajs/vue3';

export default {
    name: 'DashboardCompletedOrders',
    components: {
        LinkButton,
        ProductionProgressIcons, FileDownload, CardContent, CardTitle, CardHeader, Card
    },
    props: {
        completedOrders: Object,
        minified: Boolean,
    },
    data() {
        const productionStartForm = useForm({
            orders: [],
        });

        return {productionStartForm};
    },
    computed: {
        completedOrdersTable() {
            let orders = Array;

            return Object.keys(this.completedOrders).map(key => {
                orders[key] = this.completedOrders[key];

                orders[key].url = this.$$route('order', {'producerOrder': orders[key].id});

                orders[key].price_string = this.$currency(orders[key].price);

                orders[key].created_at_string = this.$date(orders[key].created_at);

                orders[key].delivery_date_string = this.$date(orders[key].delivery_date);

                orders[key].planned_production_start_at_string = orders[key].planned_production_start_at ? this.$date(orders[key].planned_production_start_at) : this.$gettext('k.A.');

                orders[key].planned_production_start_at_min_date = this.$moment(orders[key].delivery_date).subtract(this.$page.props.factors.delivery_time_producer_part, 'days').format('YYYY-MM-DD');

                orders[key].shipping_date = this.$moment(orders[key].delivery_date).subtract(this.$page.props.factors.delivery_time_part_client, 'days').format('DD.MM.YYYY');

                this.productionStartForm.orders[orders[key].id] = {planned_production_start_at: null};

                orders[key].status_string = this.$readableStatusProducer(orders[key].ask_for_quote.status);

                return orders[key];
            });
        },
        noOrders() {
            return this.completedOrders.length === 0;
        },
    },
};
</script>
